{
  "groups": {
    "boundariesSlots": "Limites / Positions",
    "controls": "Commandes",
    "general": "Général",
    "monitoring": "Surveillance",
    "speedFlow": "Vitesse / Débit"
  },
  "linkedDevice": {
    "deviceAlias": "Alias de l'appareil"
  },
  "stopDetection": {
    "description": "Vous envoie un SMS lorsque ce pivot est détecté en train d'appliquer de l'eau sans se déplacer, en restant dans le rayon de distance minimale pendant toute la fenêtre de temps.",
    "label": "Détection d'arrêt (GPS)",
    "minimumDistance": "Distance minimale",
    "timeWindow": "Fenêtre de temps",
    "wheelDescription": "Vous envoie un SMS lorsque le capteur de roue du moniteur lié détecte que ce pivot a cessé de se déplacer.",
    "wheelLabel": "Détection d'arrêt (roue)",
    "wheelUpdateFailed": "Impossible de mettre à jour la notification d'arrêt de roue. Veuillez réessayer."
  }
}
